import enUS from "date-fns/locale/en-US";
import ja from "date-fns/locale/ja";
import React, { useEffect } from "react";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { useSelector } from "react-redux";

import LoginContainer from "../containers/LoginContainer";

import AlertDialog from "./AlertDialog";
import ConfirmDialog from "./ConfirmDialog";

import { AuthenticatedApp } from "@/components/AuthenticatedApp";
import { RootState } from "@/reducers/types";

registerLocale("ja", ja);
registerLocale("en-US", enUS);
setDefaultLocale("ja");

const App = () => {
  const { confirm, alert, unloadAlert } = useSelector((state: RootState) => state.app);
  const { valid: authenticated } = useSelector((state: RootState) => state.session);
  const { system } = useSelector((state: RootState) => state.session);

  const showUnloadAlert = (e) => {
    if (unloadAlert) {
      e.preventDefault();
      e.returnValue = "";

      return "";
    }

    return undefined;
  };

  useEffect(() => {
    window.addEventListener("beforeunload", showUnloadAlert);

    return () => {
      window.removeEventListener("beforeunload", showUnloadAlert);
    };
  }, []);

  return (
    <>
      {authenticated ? (
        <AuthenticatedApp />
      ) : (
        <>
          <LoginContainer />
          {confirm !== null && <ConfirmDialog {...confirm} />}
        </>
      )}
      {alert !== null && <AlertDialog {...alert} from={system} />}
    </>
  );
};

export default App;
